import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover, Radio, RadioGroup } from "@mui/material";
import { FormatColorFill, Settings, Visibility } from "@mui/icons-material";
import { MuiColorInput } from "mui-color-input";
import Service from "../../../util/Service";
import GaleriaComp from "../../util/GaleriaComp";


export default function KanbanConfig(props) {
    const { kanban, action } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openDialogCor, setOpenDialogCor] = React.useState(false);
    const [value, setValue] = React.useState('cor');
    const [cor, setCor] = React.useState("#fff");

    React.useEffect(()=>{
        if( kanban){
            if(kanban.fundo){
                if( kanban.fundo.cor)setCor(kanban.fundo.cor);
            }
        }
    },[kanban]);
    const handleCloseDialogCor = () => {
        setOpenDialogCor(false);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    function handleClickOpen(event) {
        setAnchorEl(event.currentTarget);
    }
    const handleChange = (event) => {
        setValue(event.target.value);
      };
    const montaTelaCor=()=>{
        if(value === 'cor'){
            return (
                <MuiColorInput format="hex" value={cor} onChange={(c) =>setCor(c)} />
            )
        }
        if( value === 'geleria'){
            return(
                <GaleriaComp onAction={criaFromGaleria} onClose={() =>{
                    handleCloseDialogCor();
                }}/>
            )
        }
    }
    const criaFromGaleria=(src)=>{
        const fonte = "/api/getAnexoById/"+src.id;
        
        handleSaveCorGenerico({anexo: src.id})
    }
    const handleRemoverFundo=()=>{
        handleSaveCorGenerico({cor:''});
    }
    const handleSaveFundo=()=>{
        if( value === 'cor') handleSaveCorGenerico({cor:cor});
    }
    const handleSaveCorGenerico=(fundo)=>{
        const dado = {
            idKanban: kanban.id,
            fundo: {}
        }
        dado.fundo = fundo;
        Service.POST("/api/projeto/kanbanFundo", dado).then( r=> {
            if(r.success){
                action(r.kanban);
                handleClose();
                handleCloseDialogCor();
            }else{
                alert(r.msg);
            }
        })
    }
    return (
        <React.Fragment>
            <Button startIcon={<Settings />} size='small'
                onClick={handleClickOpen}
            >
                Configurações
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List
                    sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                >
                    <ListItem disablePadding>
                        <ListItemButton onClick={()=>setOpenDialogCor(true)}>
                            <ListItemIcon>
                                <FormatColorFill />
                            </ListItemIcon>
                            <ListItemText primary="Estilo de fundo" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <Visibility />
                            </ListItemIcon>
                            <ListItemText primary="Visibilidade: privado" />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Popover>

            <Dialog
                open={openDialogCor}
                onClose={handleCloseDialogCor}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Estilo de fundo do quadro
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Qual o tipo:
                    </DialogContentText>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={value}
                            onChange={handleChange}
                        >
                            <FormControlLabel value="link" control={<Radio />} label="Link" />
                            <FormControlLabel value="geleria" control={<Radio />} label="Galeria" />
                            <FormControlLabel value="cor" control={<Radio />} label="Cor de fundo" />
                        </RadioGroup>
                        </FormControl>
                        {montaTelaCor()}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleRemoverFundo}>Remover</Button>
                    <Button onClick={handleCloseDialogCor}>Cancelar</Button>
                    <Button onClick={handleSaveFundo} autoFocus>
                        Alicar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )

}